__turbopack_context__.v({
  "expandable": "ExpandableFinance-module__TjFMYG__expandable",
  "finance": "ExpandableFinance-module__TjFMYG__finance",
  "financeCopy": "ExpandableFinance-module__TjFMYG__financeCopy",
  "financePrice": "ExpandableFinance-module__TjFMYG__financePrice",
  "noFinance": "ExpandableFinance-module__TjFMYG__noFinance",
  "readMe": "ExpandableFinance-module__TjFMYG__readMe",
});
